var render = function render(){var _vm=this,_c=_vm._self._c;return (this.$vuetify.breakpoint.smAndDown)?_c('nav-bar-collapsed'):_c('nav-bar-full')
}
var staticRenderFns = []

export { render, staticRenderFns }